import React, { useState, useEffect } from 'react'
import { Route } from 'react-router-dom'
import moment from 'moment'
import { Store } from '../../context/store'
import { getData } from '../../helpers'
import { useInterval, useFetch } from '../../hooks'
import Container from '../../components/Container'
import { FooterStyled, FooterContent, NavLinkStyled, StyledFooterItemWrapper, StyledFooterItem, IconStyled, StyledIconAlert } from './styled'

const NavLinkWithChildrenFunc = ({ to, exact = false, children, ...rest }) => (
    <Route path={to} exact={exact}>
        {({ match }) => (
            <NavLinkStyled to={to} {...rest}>
                {typeof children === 'function'
                    ? children(match)
                    : children
                }
            </NavLinkStyled>
        )}
    </Route>
)

const Footer = React.memo(({ children }) => {
    const { state: { app: { alerts } }, actions } = Store()
    const [delay, setDelay] = useState(1000 * 60 * 10) //10 minutes

    const { doFetch: doFetchLastAlerts } = useFetch({
        url: '/lastalerts',
        method: 'GET',
        action: actions.setAlerts,
        lazy: true,
        reload: false
    })

    useEffect(() => {
        doFetchLastAlerts()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const calcDiffTime = () => moment().diff(moment.unix(alerts.lastUpdate), 'minutes')

    useInterval(() => {
        if (calcDiffTime() >= 1) {
            (async () => {
                try {
                    await doFetchLastAlerts()
                } catch (err) {
                    setDelay(null)
                }
            })()
        }
    }, delay)

    const alertsData = getData(alerts)

    return (
        <FooterStyled>
            <Container>
                <FooterContent>
                    <StyledFooterItemWrapper>
                        <NavLinkWithChildrenFunc
                            to="/monitoring"
                            activeClassName="active"
                            children={(match) => (
                                <StyledFooterItem>
                                    <IconStyled name={`monitoring_${!!match ? 'active' : 'inactive'}`} pointer active={!!match} />
                                    {
                                        (alertsData && alertsData.monitoring) &&
                                        <StyledIconAlert name='alarm' />
                                    }
                                </StyledFooterItem>
                            )}
                        />
                    </StyledFooterItemWrapper>
                    {
                        children &&
                        <StyledFooterItemWrapper>
                            <StyledFooterItem>{children}</StyledFooterItem>
                        </StyledFooterItemWrapper>
                    }
                    <StyledFooterItemWrapper>
                        <NavLinkWithChildrenFunc
                            to="/manage"
                            activeClassName="active"
                            children={(match) => (
                                <StyledFooterItem>
                                    <IconStyled name={`manage_${!!match ? 'active' : 'inactive'}`} pointer active={!!match} />
                                    {
                                        (alertsData && alertsData.objects) &&
                                        <StyledIconAlert name='alarm' />
                                    }
                                </StyledFooterItem>
                            )}
                        />
                    </StyledFooterItemWrapper>
                </FooterContent>
            </Container>
        </FooterStyled>
    )
})

export default Footer